import styled, { keyframes } from 'styled-components';

import { mobile } from '@techstyle/react-components';

export const StyledCreateAccount = styled.p`
  ${props => props.theme.paragraph.variants.paragraph1.textStyles}
  color:  ${({ theme }) => theme.colors.white};
  margin-top: 8px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  text-align: center;
  ${mobile`
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
  `}
`;

export const StyledSavageLogo = styled.img`
  margin-top: 20px;
  width: 248px;
`;

export const StyledNewRewardsText = styled.p`
  ${props => props.theme.paragraph.variants.paragraph1.textStyles}
  color:  ${({ theme }) => theme.colors.white};
  margin-top: 8px;
  font-weight: 400;
  ${mobile`
      margin-top: 6px;
  `}
  #gift-box-promo-expand-container[is-active='true'] & {
    animation-name: ${keyframes`
      from {
        opacity: 0;
        font-size: 1px;
      }
      to {
        opacity: 1;
        font-size: 14px;
      }
    `};
    ${mobile`
      animation-name: ${keyframes`
        from {
          opacity: 0;
          font-size: 1px;
        }
        to {
          opacity: 1;
          font-size: 12px;
        }
      `};
    `}
    animation-duration: 1.5s;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-fill-mode: forwards;
  }
`;

export const StyledCongrats = styled.h2`
  margin-block: 0px;
  ${({ theme }) => theme.header.variants.h2.textStyles}
  color:  ${({ theme }) => theme.colors.white};
  font-weight: 600;
  #gift-box-promo-expand-container[is-active='true'] & {
    animation-name: ${keyframes`
      from {
        opacity: 0;
        font-size: 1px;
      }
      to {
        opacity: 1;
        font-size: 20px;
      }
    `};
    ${mobile`
      animation-name: ${keyframes`
        from {
          opacity: 0;
          font-size: 1px;
        }
        to {
          opacity: 1;
          font-size: 16px;
        }
      `};
    `}
    animation-duration: 1.5s;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-fill-mode: forwards;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  margin: -64px 0px 0px;
  &[data-should-center='true'] {
    margin: auto 0px;
  }
  height: 77.5%;
  ${mobile`
    height: 75%;
    margin: -72px 0px 0px;
    &[data-should-center='true'] {
      margin: auto 0px;
    }
  `}
`;
export const StyleSitePromo = styled.h2`
  ${({ theme }) => theme.header.variants.h2.textStyles}
  color:  ${({ theme }) => theme.colors.white};
  margin-top: 8px;
  margin-block-start: 8px;
  margin-block-end: 0px;
  font-weight: 400;
  text-align: center;
  line-height: 32px;
  ${mobile`
    margin-top: 6px;
    margin-block-start: 6px;
    margin-block-end: 0px;
    line-height: 28px;
  `}
  #gift-box-promo-expand-container[is-active='true'] & {
    animation-name: ${keyframes`
      from {
        opacity: 0;
        font-size: 1px;
      }
      to {
        opacity: 1;
        font-size: 40px;
      }
    `};
    ${mobile`
      animation-name: ${keyframes`
        from {
          opacity: 0;
          font-size: 1px;
        }
        to {
          opacity: 1;
          font-size: 35px;
        }
      `};
    `}
    animation-duration: 1.5s;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-fill-mode: forwards;
  }
`;

export const StyledContainer = styled.div`
  width: 520px;
  height: 740px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  padding: 30px 20px 10px;
  align-items: center;
  background: linear-gradient(
    127.17deg,
    ${({ theme }) => theme.colors.lavender} 16.23%,
    ${({ theme }) => theme.colors.lavender500} 97.26%
  );

  ${mobile`
      width: 350px;
      height: 648px;
    `}
`;

export const GiftForYouText = styled.h2`
  ${({ theme }) => theme.header.variants.h2.textStyles}
  font-weight: 40px;
  margin-top: 80px;
  margin-block-start: 80px;
  margin-block-end: 0px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  font-size: 60px;

  ${mobile`
    font-size: 50px;
  `}
`;

export const StyledGiftBoxContainer = styled.div`
  margin-top: 80px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const StyledGiftForYouSubHeading = styled.p`
  ${props => props.theme.paragraph.variants.paragraph1.textStyles}
  color:  ${({ theme }) => theme.colors.white};
  margin-top: 80px;
  font-size: 24px;
  font-weight: 400;
  text-align: center;
  ${mobile`
    font-size: 20px;
  `}
`;

export const PromoExpandContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  top: 110px;

  overflow: hidden;
  height: 0;
  transition: height 1s ease-out 0.5s, top 1s ease-out 3s;

  &[is-active='true'] {
    height: 200px;
    top: 0px;
  }

  ${mobile`
      top: 80px;

      &[is-active='true'] {
        height: 200px;
        top: 0px;
      }
  `}
`;

export const GiftBoxOpenImage = styled.img`
  height: 240px;
  width: 240px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  ${mobile`
      height: 180px;
      width: 180px;
    `}
`;

export const GiftBoxImage = styled.img`
  width: 80px;
  height: 80px;
  cursor: pointer;
  transition: transform 0.3s ease, filter 0.3s ease;

  &:hover {
    transform: scale(1.2) translateY(-2px);
    filter: drop-shadow(0 12px 20px rgba(0, 0, 0, 0.4))
      drop-shadow(0 0 5px rgba(78, 115, 223, 0.3));
  }

  ${mobile`
    width: 60px;
    height: 60px;

    &[data-highlight='true'] {
    transform: scale(1.2) translateY(-2px);
    filter: drop-shadow(0 12px 20px rgba(0, 0, 0, 0.4))
      drop-shadow(0 0 5px rgba(78, 115, 223, 0.3));
  }`}
`;
